<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    石厦站<br>
站点介绍<br>
石厦站位于福民路与石厦北二街交汇处。北侧是中央花园住宅区，东北角有东方欣悦居，南侧是马成时代广场，东端是福田区委及福田区行政办公楼，西南侧为天虹商场。石厦站装修设计为碧海蓝天，体现“大海宽广的胸襟与青青草原相辅相成特色，采用海蓝＋碧绿冷色基调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	00:09	3号线	2分15-20秒	4分30秒<br>
双龙	06:22	23:04	3号线	2分15-20秒	4分30秒<br>
西丽湖	06:29	23:28	7号线	3分35秒	5分55秒<br>
太安	06:07	23:28	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	00:08	3号线	3分15秒	5分钟<br>
双龙	06:22	23:04	3号线	3分15秒	5分钟<br>
西丽湖	06:23	23:28	7号线	4分钟	5分55秒<br>
太安	06:06	23:28	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:29	01:08	3号线	3分15秒	5分钟<br>
双龙	06:22	00:04	3号线	3分15秒	5分钟<br>
西丽湖	06:23	00:28	7号线	4分钟	5分55秒<br>
太安	06:06	00:28	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
福民路北侧（东）、石厦北三街、博伦花园、瑞和园、明月花园、东方欣悦居<br><br>
C出入口:<br>
石厦北二街、石厦北四街、石厦北六街、福田区石厦学校小学部、石厦学校中学部、金地翠园<br><br>
E出入口:<br>
福民路北侧（西）、石厦北一街、福田区石厦学校小学部、中央花园、福田区石厦学校中学部、丽阳天下名苑、缔馨园<br><br>
F出入口:<br>
福民路南侧（西）、众孚大厦、众孚新村、众孚花园、星河明居、福民天虹<br><br>
G出入口:<br>
福民路南侧（东）、石厦街、深圳市公安局福田分局、福田区人民检察院、福田区人民法院、福田区人民政府、福田区委<br><br>
公交换乘信息<br><br>
E出入口:<br>
公交站名： 福田区委<br>
202路、212路、303路、372路、B689路、K113路、M370路、28路、33路、34路、63路、73路、103B<br><br>
G出入口:<br>
公交站名： 福田区委<br>
M389路,M390路,N10路,202路,212路,303路,372路,B689路,K113路,M370路,28路,33路,34路,63路,73路,103B路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>